// react
import { useContext } from 'react';

// context
import { ContextInvoices } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableInvoices } from '../../../../tables/cards/TableInvoices/TableInvoices';

export const Invoices = () => {
	const { invoices, isLoadingInvoices, paginationInvoices, refetchInvoices } =
		useContext(ContextInvoices);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableInvoices
						invoices={invoices}
						isLoading={isLoadingInvoices}
						pagination={paginationInvoices}
						refetchInvoices={refetchInvoices}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
